import { PdfViewer } from "../preview/PdfViewer";
import { PageFixPanel } from "./PageFixPanel";
import { API } from "../../lib/api";

export const PdfFixTab = ({ kit, reload, jump }) => (
  <div data-testid="pdf-fix-tab" className="rounded-xl border border-[#C9A847]/20 bg-white p-6">
    <PdfViewer base={`${API}/kits/${kit.id}`} v={kit.updated_at} jump={jump} side={(page) => <PageFixPanel kit={kit} page={page} reload={reload} />} />
  </div>
);
